import { EnvironmentInfo } from "../lib/api";

interface EnvSelectorProps {
  envs: EnvironmentInfo[];
  value: string;
  onChange: (env: string) => void;
}

// 对话上方的环境选择器：显式指定比在消息里提国家名更清晰，每次请求都会带上
// 当前选择（见 useChat.send），后端仍兼容消息里明确提到国家时临时切换。
export default function EnvSelector({ envs, value, onChange }: EnvSelectorProps) {
  if (envs.length === 0) return null;

  return (
    <label className="flex items-center gap-1.5 text-xs text-slate-500">
      环境
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="rounded-lg border border-slate-300 bg-white px-2 py-1 text-xs font-medium text-slate-700 outline-none focus:border-slate-500"
      >
        {envs.map((e) => (
          <option key={e.name} value={e.name}>
            {e.description ? `${e.description}（${e.name}）` : e.name}
          </option>
        ))}
      </select>
    </label>
  );
}
